export const SET_CASH_SUMMARY = 'SET_CASH_SUMMARY'
export const SET_CARD = 'SET_CARD'
